import { render, staticRenderFns } from "./BulkSalaryUpload.vue?vue&type=template&id=61bae47c"
import script from "./BulkSalaryUpload.vue?vue&type=script&lang=js"
export * from "./BulkSalaryUpload.vue?vue&type=script&lang=js"
import style0 from "./BulkSalaryUpload.vue?vue&type=style&index=0&id=61bae47c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports